module.exports = "<button id={{id}}Menu class=\"kt-dropdown-btn top-level {{style}}\" type=button ng-click=openDropdownMenu($event) controls=trav aria-expanded={{opened}} aria-haspopup=true aria-controls=#{{id}}>{{model.text || model.Text || currentValue}} <span class=dropdown-arrow></span></button><div class=\"travellers-dropdown {{style}}\" id={{id}} click-outside=\"clickOutsideDropdown(['#{{id}}Menu','#{{id}}'])\" outside-if-not={{id}}Menu aria-labelledby={{id}}Menu><ul ng-model=model class=dropdown-options><div ng-transclude></div></ul></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/templates/dropdown-html-kt.tmpl.html
// module id = 570
// module chunks = 0